export const SECOND = 1000;

export const MINUTE = 60 * SECOND;

export const KILOBYTE = 1024;

export const MEGABYTE = 1024 * KILOBYTE;

export const BASE_LIMIT = 30;
